module.exports = __webpack_public_path__ + "img/img2.a0491f3a.png";